/**
 * FE billing registration audit trail — no passwords, no card data.
 * Set VITE_AGENT_REG_BILLING_LOG=1 to enable in production builds.
 */
const PREFIX = "[agentReg:billing]";

function enabled() {
  try {
    return (
      import.meta.env.DEV === true ||
      String(import.meta.env.VITE_AGENT_REG_BILLING_LOG || "").trim() === "1"
    );
  } catch {
    return false;
  }
}

function shortDraft(id) {
  if (id == null || id === "") return "(none)";
  const s = String(id);
  return s.length <= 12 ? s : `${s.slice(0, 8)}…`;
}

export function logAgentRegBilling(event, detail = {}) {
  if (!enabled()) return;
  const safe = { ...detail };
  if (safe.draftId) safe.draftId = shortDraft(safe.draftId);
  console.info(PREFIX, event, safe);
}
